import * as React from "react"
import { SVGProps } from "react"

interface ArrowDownMobileProps extends SVGProps<SVGSVGElement> {
  color?: string
}

const ArrowDownMobile = ({ color = "#97A0AF", ...props }: ArrowDownMobileProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    style={{ color }}
    {...props}
  >
    <path
      fill="currentColor"
      d="m8 9.4 3.9-3.9a.948.948 0 0 1 .7-.275c.284 0 .517.091.7.275a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7l-4.6 4.6c-.1.1-.208.17-.325.213a1.149 1.149 0 0 1-.75 0A.851.851 0 0 1 7.3 11.5L2.7 6.9a.948.948 0 0 1-.275-.7c0-.284.092-.517.275-.7a.948.948 0 0 1 .7-.275c.284 0 .517.091.7.275L8 9.4Z"
    />
  </svg>
)

export default ArrowDownMobile
